import React, { Component } from 'react';
import { Button, Modal } from 'semantic-ui-react';
import Select from 'components/Form/Select';
import { Field, Formik, Form } from 'formik';
import * as Yup from 'yup';
import moment from 'moment';

const schemaValidation = Yup.object().shape({
	originalBarcode: Yup.string().required('Champ requis')
});

class ReuseTubeModal extends Component {
	render() {
		const { reusableTubes, open, close, submit } = this.props;

		return (
			<Modal
				size='small'
				open={open}
				closeOnEscape
				closeOnDimmerClick
				onClose={close}
			>
				<Modal.Header>Réutiliser un tube</Modal.Header>
				<Formik
					enableReinitialize
					initialValues={{
						originalBarcode: '',
					}}
					validationSchema={schemaValidation}
					onSubmit={(values) => {
						submit(values.originalBarcode);
						close();
					}}
				>
					{({ submitForm }) => (
						<>
							<Modal.Content>
								Veuillez sélectionner un tube qui à déjà été prélevé afin de le
								réutiliser
								<Form>
									<Field
										component={Select}
										name='originalBarcode'
										customlabel='Tube'
										placeholder='Sélectionner un tube'
										options={reusableTubes?.map((tube) => ({
											value: tube.provider_barcode,
											label: `Tube ${tube.provider_barcode} prélevé le ${moment(
												tube.sampling_time
											).format(
												`${process.env.REACT_APP_DATE_DISPLAY_FORMAT} à ${process.env.REACT_APP_TIME_DISPLAY_FORMAT}`
											)} - Volume restant : ${tube.remaining_volume} ml`,
										}))}
										required
									/>
								</Form>
							</Modal.Content>

							<Modal.Actions>
								<Button
									onClick={(e) => {
										if (e !== undefined) e.preventDefault();
										close();
									}}
								>
									Annuler
								</Button>
								<Button
									primary
									onClick={(e) => {
										if (e !== undefined) e.preventDefault();
										submitForm();
									}}
								>
									Confirmer
								</Button>
							</Modal.Actions>
						</>
					)}
				</Formik>
			</Modal>
		);
	}
}

export default ReuseTubeModal;
